import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  headerContainer: {
    position: 'sticky',
    top: '0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    cursor: 'default'
  },

  taskItemHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    fontSize: theme.size.sm
  },

  separator: {
    padding: '0 0 0.5rem 0',

    '& > div': {
      height: '1px',
      background: '#F1F1F1'
    }
  },

  taskItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75rem',
    cursor: 'pointer',
    fontSize: theme.size.sm,

    [theme.breakpoints.down('lg')]: {
      marginBottom: '1.5rem'
    }
  },

  mobileColors: {
    maxWidth: '145px',

    [theme.breakpoints.up('xl')]: {
      flexBasis: '50%'
    },

    [theme.breakpoints.down('xl')]: {
      flexBasis: '60%'
    },

    [theme.breakpoints.down('lg')]: {
      flexBasis: '15%'
    }
  },

  statusColors: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center'
    }
  },

  dot: {
    marginRight: '1rem',
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '11px',
    height: '11px'
  },

  statusTitle: {
    [theme.breakpoints.down('lg')]: {
      display: 'none'
    }
  },

  taskTitles: {
    flexBasis: '60%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    [theme.breakpoints.up('xl')]: {
      flexBasis: '50%',
      maxWidth: 'unset'
    },

    [theme.breakpoints.down('lg')]: {
      marginLeft: '0'
    },

    [theme.breakpoints.down(600)]: {
      maxWidth: '15rem'
    },

    [theme.breakpoints.down(400)]: {
      maxWidth: '10rem'
    }
  }
}))

export default useStyles
